import { ConfirmCancelOrderSchema } from "@redotech/redo-agents-cards/support-agents/confirm-cancel-order";
import * as z from "zod";
import { boolean, literal, object } from "zod";
import { ContentType } from "../../conversation";
import {
  AutoGeneratedFieldsSchema,
  BaseToolCallMessageSchema,
  WithoutId,
} from "../message-parser-utils";
export const CancelOrderCustomerInputContentSchema = object({
  cancelled: boolean().optional(),
});

export const CancelOrderMessageSchema = BaseToolCallMessageSchema.extend({
  contentType: literal(ContentType.CANCEL_ORDER),
  structuredContent: ConfirmCancelOrderSchema.required(),
  customerInputContent: CancelOrderCustomerInputContentSchema.optional(),
});

export const CancelOrderMessageDbParser = CancelOrderMessageSchema.merge(
  AutoGeneratedFieldsSchema,
);
export type CancelOrderMessageType = z.infer<typeof CancelOrderMessageDbParser>;
export type CancelOrderMessageTypeWithoutId = WithoutId<CancelOrderMessageType>;
